import React, { useState } from 'react';
import './AddCalendarEventModal.css';

const COLOR_OPTIONS = ['#c01f2d', '#2563eb', '#059669', '#7c3aed', '#db2777', '#9f1a26', '#d97706'];

const initialForm = {
  title: '',
  start: '',
  end: '',
  time: '',
  location: '',
  description: '',
  color: COLOR_OPTIONS[0],
};

export default function AddCalendarEventModal({ isOpen, onClose, onSave, defaultDate }) {
  const [form, setForm] = useState(() => ({
    ...initialForm,
    start: defaultDate || '',
    end: defaultDate || '',
  }));

  if (!isOpen) return null;

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.start) {
      window.alert('Please enter an event title and start date.');
      return;
    }

    const end = form.end || form.start;
    if (end < form.start) {
      window.alert('End date cannot be before the start date.');
      return;
    }

    const detailLines = [];
    if (form.time) detailLines.push(form.time);
    if (form.location) detailLines.push(form.location);
    if (form.description.trim()) detailLines.push(form.description.trim());

    onSave({
      id: `custom-${Date.now()}`,
      title: form.title.trim(),
      start: form.start,
      end,
      color: form.color,
      highlight: true,
      detailLines,
      time: form.time || null,
      note: form.location || null,
    });

    setForm({ ...initialForm, start: defaultDate || '', end: defaultDate || '' });
    onClose();
  };

  return (
    <div className="calendar-event-overlay" onClick={onClose} role="presentation">
      <div
        className="calendar-event-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="calendar-event-title"
        aria-modal="true"
      >
        <button type="button" className="calendar-event-close" onClick={onClose} aria-label="Close">
          &times;
        </button>
        <h2 id="calendar-event-title" className="calendar-event-heading">Add calendar event</h2>
        <form className="calendar-event-form" onSubmit={handleSubmit}>
          <label className="calendar-event-label">
            Event title
            <input
              type="text"
              value={form.title}
              onChange={(e) => updateField('title', e.target.value)}
              required
            />
          </label>

          <div className="calendar-event-row">
            <label className="calendar-event-label">
              Start date
              <input
                type="date"
                value={form.start}
                onChange={(e) => updateField('start', e.target.value)}
                required
              />
            </label>
            <label className="calendar-event-label">
              End date
              <input
                type="date"
                value={form.end}
                onChange={(e) => updateField('end', e.target.value)}
              />
            </label>
          </div>

          <div className="calendar-event-row">
            <label className="calendar-event-label">
              Time
              <input
                type="text"
                value={form.time}
                onChange={(e) => updateField('time', e.target.value)}
                placeholder="8:00 PM"
              />
            </label>
            <label className="calendar-event-label">
              Location
              <input
                type="text"
                value={form.location}
                onChange={(e) => updateField('location', e.target.value)}
                placeholder="(In-Person @ Church)"
              />
            </label>
          </div>

          <label className="calendar-event-label">
            Description
            <textarea
              rows={3}
              value={form.description}
              onChange={(e) => updateField('description', e.target.value)}
              placeholder="Optional details for the event popup"
            />
          </label>

          <fieldset className="calendar-event-colors">
            <legend>Color</legend>
            <div className="calendar-event-color-options">
              {COLOR_OPTIONS.map((color) => (
                <button
                  key={color}
                  type="button"
                  className={`calendar-event-color ${form.color === color ? 'is-selected' : ''}`}
                  style={{ backgroundColor: color }}
                  onClick={() => updateField('color', color)}
                  aria-label={`Use color ${color}`}
                />
              ))}
            </div>
          </fieldset>

          <button type="submit" className="calendar-event-submit">
            Add event
          </button>
        </form>
      </div>
    </div>
  );
}
